import { render, staticRenderFns } from "./ItemEmpresaDetail.vue?vue&type=template&id=ef34d8e8&scoped=true&"
import script from "./ItemEmpresaDetail.vue?vue&type=script&lang=js&"
export * from "./ItemEmpresaDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItemEmpresaDetail.vue?vue&type=style&index=0&id=ef34d8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef34d8e8",
  null
  
)

export default component.exports